import { useState, useEffect, Fragment, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { documentsActions } from "../../actions/documentsActions"
import { makeStyles } from "@material-ui/core/styles"
import { operationsHelper } from "../../helpers/operations"
import { dataHelper } from "../../helpers/dataextraction"
import MetadataLayout from "../general/MetadataLayout"
import { sourceHelper } from "../../helpers/sourceHelper"
import Pagination from "../common/Pagination"
import BulkDownload from "../common/bulkDownload"
import PaginationInput from "../common/PaginationInput"
import DocumentModal from "../common/DocumentModal"
import axios from "../../services/axios"
import CommentsDetailsModal from "../documents/CommentsDetailsModal"
import CommentsList from "../documents/CommentsList"
import { getCommentsCount, METADATA } from "../../utils"
import TagsUpdateDropdown from "../common/TagsUpdateDropdown"
import PrevNextButtons from "../common/PrevNextButtons"
import MUIPagination from "@material-ui/lab/Pagination"
import { getDocumentsRequest, updateMetadata } from "../../actions/viewdocumentsActions"
import { getDocumentRowClickRequest } from "../../actions/documentModalActions"
import { useDebounce, PAGINATION_DELAY } from "../../utils"
import TableView from "../common/TableView/TableView"
import { IconButton } from "@material-ui/core"
import { AddIcon } from "@material-ui/icons"

export const ElementsListAllDocuments = ({
	elementsFilter,
	filtersButton,
	setDocumentslist,
	filterList,
	filterDate,
	needToFilter,
	setNeedToFilter,
	page,
	setPage,
	pageCount,
	setPageCount,
	recordsPerPage,
	setRecordsPerPage,
}) => {
	/* ******************* REDUX STORE ******************* */
	//Redux actions
	const dispatch = useDispatch()
	const globalStateViewDocumentList = useSelector((state) => state.viewdocuments.allDocuments)
	const allDocumentsCount = useSelector((state) => state.viewdocuments.allDocumentsCount)
	const documentLoading = useSelector((state) => state.viewdocuments.documentLoading)
	const documentLoadingInBackground = useSelector((state) => state.viewdocuments.allDocumentsLoadingInBackground)
	const viewDocument = useSelector((state) => state.viewdocuments.document)
	const conceptsOfSearch = useSelector((state) => state.viewdocuments.currentConceptTargetTerms)
	//Access store state
	const isLoading = useSelector((state) => state.viewdocuments.allDocumentsLoading)
	const alert = useSelector((state) => state.alert.alert)
	const downloadDocs = useSelector((state) => state.downloads.documents)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const updateCommentsRequest = useSelector((state) => state.document.reloadComments)
	const comentsCount = useSelector((state) => state.document.doc_counts)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Data state
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	// State to manage the elements mouseOver
	const [itemId, setItemId] = useState()
	const [currentpage, setCurrentPage] = useState(1)
	const [totalpages, setTotalPages] = useState(1)
	// Get Item Content
	const [item, setItem] = useState({
		idItem: "",
		contentItem: "",
	})
	// Select MouseOver / MouseOut
	const [selectOver, setSelectOver] = useState(false)
	// getModalStyle is not a pure function, we roll the style only on the first render
	const [modalStyle] = useState(getModalStyle)
	const [open, setOpen] = useState(false)
	const [selectIdentify, setSelectIdentify] = useState({
		show: false,
		value: "",
		elementId: "",
		color: "",
	})
	const [selectDateDocument, setSelectDateDocument] = useState({
		show: false,
		date: "",
		elementId: "",
	})
	//Current hightlight text word index
	const [hightlightIndex, setHightlightIndex] = useState(null)

	// Get document content
	const [content, setContent] = useState({
		documentId: "",
		documentText: "",
		documentSubject: "",
		documentFrom: "",
		documentTo: "",
		errorDocumentText: null,
	})

	//Docs to show - Pagination
	const [docsToSHow, setDocsToSHow] = useState({ count: 0, data: [] })
	// BULK BUTTONS
	const [activeCheckbox, setActiveCheckbox] = useState(false)
	// Bulk checked
	const [bulkChecked, setBulkChecked] = useState(new Array(docsToSHow.data.length).fill(false))
	// Documents selected - Bulk download
	const [documentsBulk, setDocumentsBulk] = useState([])
	// All selected
	const [allChecked, setAllChecked] = useState(false)

	const [showingCommentBox, setShowingCommentBox] = useState(false)
	const [showingCommentBoxId, setShowingCommentBoxId] = useState(null)

	//Docs Comments
	const [comment, setComment] = useState("")
	const [commentList, setCommentList] = useState([])
	const [commentContent, setCommentContent] = useState()

	// Refresh element
	const [idElement, setIdElement] = useState(Math.random())
	const [inputPageNumber, setInputPageNumber] = useState(page)
	/* ******************* END REACT STATES ******************* */

	const debouncedTerm = useDebounce(inputPageNumber, PAGINATION_DELAY)

	/* ******************* VARIABLES ******************* */
	//DB click control
	let timer = 0
	let delay = 200
	let prevent = false
	// Pagination
	let elementsPerPage = 20
	let calcTotalPages = Math.ceil(searchDocumentsList.data?.length / elementsPerPage)
	const filtersObject = { ...filtersButton, ...filterList }
	const wrapperRef = useRef(null)
	let dispatchDocs = null
	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	useEffect(() => {
		if (debouncedTerm !== "" && Number(debouncedTerm) >= 1 && Number(debouncedTerm) <= pageCount) setPage(Number(debouncedTerm))
		else {
			setInputPageNumber(page)
		}
	}, [debouncedTerm])

	useEffect(() => {
		setActiveCheckbox(false)
	}, [selectedBaseId])

	//Reload comments when updating
	useEffect(() => {
		if (updateCommentsRequest === true) {
			updateCommentList(showingCommentBoxId)
			dispatch(documentsActions.updateCommentRequest(false))
		}
	}, [updateCommentsRequest])

	const updateCommentList = async (docId) => {
		//get comment list form backend
		//setCommentList([]);
		//const response = await documentsService.getComments(docId);
		const response = await axios.get(`/documents/comments/${docId}`)
		if (response.hasOwnProperty("data") && response.data.hasOwnProperty("data")) {
			setCommentList(response.data.data)
			dispatch(documentsActions.storeCommentCountRequest(docId, response.data.data.length))
		}

		return
	}

	useEffect(() => {
		if (searchDocumentsList.count > 0) {
			let auxToShow = {
				count: searchDocumentsList.count,
				data: searchDocumentsList.data,
			}
			auxToShow = {
				count: auxToShow.count,
				data: auxToShow.data.slice(20 * (currentpage - 1), 21 * currentpage - currentpage),
			}
			setDocsToSHow({
				count: auxToShow.count,
				data: auxToShow.data,
			})
		} else {
			setDocsToSHow({
				count: 0,
				data: [],
			})
		}
	}, [searchDocumentsList, currentpage])

	useEffect(() => {
		setDocumentslist(searchDocumentsList)
		calcTotalPages = Math.ceil(searchDocumentsList.data?.length / elementsPerPage)
	}, [searchDocumentsList])

	//Close date modal when success
	useEffect(() => {
		if (alert && alert.type === "modal" && alert.class === "alert alert-success") {
			if (selectDateDocument.date) {
				setItem({ ...item, date: new Date(selectDateDocument.date).getTime() })
			}
			setSelectDateDocument({
				show: false,
			})
		}
	}, [alert])

	//Reload documents
	// useEffect(() => {
	//     // dispatch(loadDocumentsOfConcept(filtersObject));
	//     dispatch(loadDocumentsOfConcept(filtersObject));
	// }, [conceptsOfSearch]);

	useEffect(() => {
		filtering()
		return
	}, [globalStateViewDocumentList, elementsFilter, filtersButton, filterList, filterDate])

	useEffect(() => {
		//To do : To fix filter change which should be specific to date filter
		setInputPageNumber(1) //if chnage in filter will reset the pageNumber
	}, [filterList, filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		if (needToFilter === true) {
			filtering()
			setNeedToFilter(false)
		}

		return
	}, [needToFilter])

	useEffect(() => {
		setSearchDocumentslist(globalStateViewDocumentList)
		filtering()
		return
	}, [globalStateViewDocumentList])

	useEffect(() => {
		setTotalPages(calcTotalPages)
		setCurrentPage(1)
		return
	}, [calcTotalPages])

	//Update number of elements shown in list
	useEffect(() => {
		var elements = document.getElementsByClassName("conceptLoaded")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptLoaded_page_" + currentpage) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpage])

	useEffect(() => {
		if (selectIdentify.elementId !== undefined && selectIdentify.elementId !== "") {
			try {
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-warning")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-danger")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-success")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("circleHidden")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.backgroundColor = operationsHelper.getTagColor(
					selectIdentify.value,
					tagsApi
				)
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.display = "block"
			} catch (e) {}
		}
	}, [selectIdentify])

	useEffect(() => {
		if (viewDocument?.id || viewDocument?.document_id) {
			setItem({
				idItem: viewDocument.id ? viewDocument.id : viewDocument.document_id,
				contentItem: viewDocument.content,
				source: viewDocument.source,
				title: viewDocument.title,
				comments_count: viewDocument.comments_count,
				date:
					viewDocument.hasOwnProperty("tagged_date") &&
					viewDocument.tagged_date !== null &&
					viewDocument.tagged_date !== undefined
						? viewDocument.tagged_date
						: Math.floor(Date.now() / 1000),
				file_name: viewDocument.file_name,
				pageNum: viewDocument.hasOwnProperty("page_number") ? viewDocument.page_number : 1,
				totalPages: viewDocument.hasOwnProperty("total_page_number") ? viewDocument.total_page_number : 1,
			})

			getDocumentContent(viewDocument.id, viewDocument.content)
			//updateCommentList(item.id);
			setCommentList(viewDocument.comments)
			//dispatch(documentsActions.storeCommentCountRequest(viewDocument.id, viewDocument.comments.length));
			setShowingCommentBoxId(viewDocument.id)

			//update metadata in the list
			const data = {}
			data[METADATA.TAG] = viewDocument.tags?.id || ""
			data[METADATA.COMMENT] = viewDocument.comments_count
			data[METADATA.DATE] = viewDocument.tagged_date

			dispatch(updateMetadata({ id: viewDocument?.id, data: data }))
		}
	}, [viewDocument])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// UPDATE DATA FILTER
	const filtering = () => {
		let newData = operationsHelper.filteringDocsBayTag(globalStateViewDocumentList, "")
		setSearchDocumentslist({
			count: globalStateViewDocumentList?.count,
			data: newData,
		})
		const numberOfPages = Math.ceil(allDocumentsCount / recordsPerPage)
		setPageCount(numberOfPages)
	}

	//Previous Page
	const prevPage = () => {
		const newCurrentPage = currentpage - 1
		if (newCurrentPage === 0) return
		setCurrentPage(newCurrentPage)
	}

	// Next Page
	const nextPage = () => {
		const newCurrentPage = currentpage + 1
		if (newCurrentPage > totalpages) return
		setCurrentPage(newCurrentPage)
	}

	// MODAL ELEMENT
	function rand() {
		return Math.round(Math.random() * 20) - 10
	}

	function getModalStyle() {
		const top = 0
		const left = 60

		return {
			top: `${top}%`,
			left: `${left}%`,
			//transform: `translate(-${top}%, -${left}%)`,
		}
	}

	const useStyles = makeStyles((theme) => ({
		paper: {
			position: "absolute",
			width: "40%",
			height: "100%",
			backgroundColor: "#9dddd6",
			//border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: "16px 15px 24px",
		},
	}))

	const handleOpen = () => {
		setOpen(true)
		setHightlightIndex(null)
	}

	const handleClose = () => {
		setOpen(false)
		setSelectIdentify({ ...selectIdentify, show: false })
		setSelectDateDocument({ ...selectDateDocument, show: false })
		setHightlightIndex(null)
		setShowingCommentBoxId(null)
	}

	// SELECT IDENTIFY
	const showSelectIdentify = (e) => {
		e.preventDefault()
		if (!selectIdentify.show) {
			setSelectIdentify({
				show: true,
			})
			setSelectDateDocument({
				show: false,
			})
		} else {
			setSelectIdentify({
				show: false,
			})
		}
	}

	const updateSelectIdentify = (tag_id, elementId) => {
		dispatch(documentsActions.setPriorityAction(elementId, tag_id))
		setSelectIdentify({
			value: tag_id,
			elementId: elementId,
		})
		//(currentConcept.description, currentConcept.ext_id, filtersObject));
	}

	// SELECT DATE DOCUMENT
	const showSelectDateDocument = (e) => {
		e.preventDefault()
		if (!selectDateDocument.show) {
			setSelectDateDocument({
				show: true,
			})
			setSelectIdentify({
				show: false,
			})
		} else {
			setSelectDateDocument({
				show: false,
			})
		}
	}

	const updateSelectDateDocument = (e, docId) => {
		e.preventDefault()
		setSelectDateDocument({
			show: true,
			date: e.target.value,
			elementId: docId,
		})
	}

	const updateDateDocument = (e) => {
		e.preventDefault()
		dispatch(documentsActions.setDocumentDateAction(selectDateDocument.elementId, selectDateDocument.date))

		//update metadata in the list
		const data = {}
		data[METADATA.DATE] = selectDateDocument.date
		dispatch(updateMetadata({ id: selectDateDocument.elementId, data: data }))
	}

	// Get dates with yellow marked background
	const maskHightlight = (text, id) => {
		let markedText = operationsHelper.cleanHTMLTags(text)
		if (filtersButton.emails === true) {
			markedText = operationsHelper.highlightEmails(markedText, id)
		}

		//Concepts and search terms highlighting is not applicable in View all documents therefore commenting this code for now
		// if (filtersButton.concepts === true){
		//     //Hay que checkear esto, porque ahora conceptsOfSearch es 1 json
		//     markedText = operationsHelper.highlightConcepts(markedText, conceptsOfSearch,id);
		// }

		if (filtersButton.dates !== false) {
			markedText = operationsHelper.hightlightDates(markedText, id)
		}

		if (filtersButton.searchWord.length !== 0 && filtersButton.specificWord === true) {
			markedText = operationsHelper.highlightWords(markedText, filtersButton.searchWord, id)
		}

		return { __html: markedText }
	}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSelectIdentify({ show: false })
					setSelectDateDocument({ show: false })
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const getDocumentContent = (idDocument, documentContent) => {
		try {
			dataHelper.extractData(documentContent, setContent, globalStateViewDocumentList, idDocument)
		} catch (error) {}
	}

	const handleRecordClick = async (id) => {
		//dispatch(getDocumentsRequest(id))
		dispatch(getDocumentRowClickRequest(id))
	}

	const handleChange = (position) => {
		const updatedCheckedState = bulkChecked.map((item, index) => {
			if (index === position) {
				return !item
			} else {
				return item
			}
		})

		setBulkChecked(updatedCheckedState)
	}

	const handleChangeAll = (active) => {
		if (active) {
			setAllChecked(false)
		} else {
			setAllChecked(true)
		}
	}

	const updateDocumentsBulk = (docId, filename) => {
		let document = {
			id: docId,
			filename: filename,
		}

		let deleteDocument = false
		let indexDoc = ""

		Object.keys(documentsBulk).map((key, index) => {
			if (documentsBulk[key].id === docId) {
				deleteDocument = true
				indexDoc = index
			}
		})

		if (deleteDocument) {
			documentsBulk.splice(indexDoc, 1)
		} else {
			documentsBulk.push(document)
		}
	}

	const selectAllDocs = () => {
		if (allChecked) {
			setBulkChecked(new Array(docsToSHow.data.length).fill(false))

			let deleteDocument = false
			let indexDoc = ""

			docsToSHow.data.map((item, i) => {
				Object.keys(documentsBulk).map((key, index) => {
					if (documentsBulk[key].id === item.id) {
						deleteDocument = true
						indexDoc = index
					}
				})

				if (deleteDocument) {
					documentsBulk.splice(indexDoc, 1)
				}
			})
		} else {
			setBulkChecked(new Array(docsToSHow.data.length).fill(true))

			docsToSHow.data.map((item, i) => {
				let document = {
					id: item.id,
					filename: item.title,
				}
				documentsBulk.push(document)
			})
		}
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES POST INITIALIZATION ******************* */
	const classes = useStyles()
	/* ******************* END VARIABLES POST INITIALIZATION ******************* */

	/* ******************* FUNCTION CALL POST INITIALIZATION ******************* */
	useOutsideAlerter(wrapperRef)
	/* ******************* END FUNCTION CALL POST INITIALIZATION ******************* */

	//Scroll to next hightlight word
	const moveToHightlight = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length
			}
			setHightlightIndex(nextH)
			document.getElementById("divModal").scrollTop = elementMark[nextH].offsetTop - 100
		} catch (e) {}
	}

	const handleInputPageChange = (e) => {
		e.preventDefault()
		setInputPageNumber(e.target.value)
		if (e.target.value !== "" && Number(e.target.value) >= 1 && Number(e.target.value) <= pageCount) {
			updatePageNumber(e, Number(e.target.value), true)
		}
	}

	const handleInputPageBlur = (e) => {
		const pageNumberValue = Math.sign(e.target.value)
		if (!pageNumberValue || Number(e.target.value) > pageCount) {
			setInputPageNumber(page)
		}
	}

	const updatePageNumber = (e, value, IsPageInputChanged) => {
		e.preventDefault()
		if (!IsPageInputChanged) setPage(value)
		setInputPageNumber(value)
	}

	const updateCommentCount = (id, commentCount) => {
		const data = {}
		data[METADATA.COMMENT] = commentCount
		dispatch(updateMetadata({ id: id, data: data }))
	}

	// const rows = globalStateViewDocumentList?.data
	// ? globalStateViewDocumentList?.data.map((docData) => ({
	// 		id: docData.file_id,
	// 		file_name: docData.filename,
	// 		author: docData.author,
	// 		tag: docData.tags,
	// 		date_time: new Date(docData?.tagged_date).toLocaleString(),
	// 		view: "—",
	// 		Comments: "-",
	// 		Action: "-",
	//   }))
	// 	: []
	console.log("docsToSHow", docsToSHow)
	const rows =
		docsToSHow.count > 0
			? docsToSHow.data.map((docData) => ({
					id: docData.id,
					file_name: docData.filename,
					author: docData.author,
					tag: docData.tags || "—",
					date_time: new Date(docData?.tagged_date).toLocaleString(),
					view: "—",
					comments: "-",
					action: "-",
			  }))
			: []
	const columns = [
		{
			field: "file_name",
			headerName: "File name",
			sortable: false,
			// resizable: true,
			width: 215,
			// renderHeader: (params) => <testElement />,
			// renderCell:(params) => <testElement />,
			// render:(row) => {row.job_type},
			// valueGetter: (params) =>
			// `${params.row.id || ''} ${params.row.name || ''}`,
			// description: ''
		},
		{
			field: "author",
			headerName: "Author",
			sortable: false,
			width: 105,
		},
		{
			field: "tag",
			// headerName: "Tag",
			sortable: false,
			width: 150,
			renderHeader: (params) => {
				return (
					// To do : Need to add "Plus icon as in UX"
					<button>
						Tags
						{/* <IconButton className="MuiDataGrid-columnHeaderTitle">
							
						</IconButton> */}
					</button>
				)
			},
		},
		{
			field: "date_time",
			headerName: "Date & Time",
			sortable: false,
			width: 170,
		},
		{
			field: "view",
			headerName: "View",
			sortable: false,
			width: 150,
		},
		{
			field: "comments",
			headerName: "Comments",
			sortable: false,
			width: 110,
		},
		{
			field: "action",
			headerName: "Action",
			sortable: false,
			width: 150,
		},
		// {
		// 	field: "action",
		// 	headerName: "Action",
		// 	width: 160,
		// 	sortable: false,
		// 	// renderCell: (params) => (
		// 	// 	<Button href="#" color="primary">
		// 	// 		View details
		// 	// 	</Button>
		// 	// ),
		// },
	]

	return (
		<div className="section mt-5 componentContainer" style={{ padding: "0 30px", width: "100%" }}>
			<Fragment>
				{isLoading ? (
					<div className="col-12 d-flex justify-content-center mt-5 mb-5">
						<div className="d-flex align-items-center alert alert-warning">
							<strong className="loading">Loading...</strong>
							<div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
						</div>
					</div>
				) : (
					<>
						{/* { docsToSHow.count > 0 ? docsToSHow.data : null } */}
						{/* {docsToSHow.count > 0 && docsToSHow.data ? null : 
                    <div className="col-12 divBlock d-flex justify-content-center" style={{paddingTop: '50px'}}>
                        <span style={{fontSize: '20px'}}>Please, select a concept to start</span>
                    </div>
                } */}
						{/* <PaginationInput
                    currentpage = {currentpage}
                    totalpages = {totalpages}
                    docsToSHow = {docsToSHow}
                    setCurrentPage = {setCurrentPage}
                /> */}
						{
							<TableView
								columns={columns}
								rows={rows}
								isLoading={isLoading}
								pageInfo={{
									pagination: true,
									pageSize: 20,
									rowsPerPageOptions: [10, 20, 50, 100, 1000],
								}}
								checkboxSelection={true}
								footerInfo={{
									hideFooter: false,
									hideSelectionCount: true,
									hidePagination: false,
								}}
								topBarInfo={{
									show: true,
									leftSection: `Total documents: ${docsToSHow.count}`,
									rightSection: "",
								}}
								totalCount={10000} //To do: Remove hard coded total count later
							/>
						}
						{pageCount > 1 && (
							<div className="col-12 d-flex justify-content-center fs-pagination">
								<br />
								{/* <div className="flex-column"> */}
								<p>
									<input
										data-cy="input_exclude_terms"
										type="number"
										name="inputNumber"
										id="number"
										className="rounded inputFilterNegative"
										style={{ marginRight: "5px", width: "75px" }}
										min={1}
										max={pageCount}
										onChange={handleInputPageChange}
										onBlur={handleInputPageBlur}
										value={inputPageNumber}
									/>
									of <b>{pageCount}</b>
								</p>
								{/* <p style={{fontSize: '10px'}}>Invalid page number</p> */}
								{/* </div> */}
							</div>
						)}

						{/* {docsToSHow.count > 0 ? (
							<BulkDownload
								docsToSHow={docsToSHow}
								activeCheckbox={activeCheckbox}
								setActiveCheckbox={setActiveCheckbox}
								bulkChecked={bulkChecked}
								setBulkChecked={setBulkChecked}
								documentsBulk={documentsBulk}
								setDocumentsBulk={setDocumentsBulk}
								allChecked={allChecked}
								setAllChecked={setAllChecked}
								isLoading={documentLoadingInBackground}
							/>
						) : null} */}

						{/* {activeCheckbox ? (
							<div>
								<label style={{ paddingRight: "8px" }}>Select All</label>
								<input
									key={`bulk_checkbox_all`}
									type="checkbox"
									checked={allChecked}
									className="form-check-input"
									onChange={(e) => {
										e.preventDefault()
										handleChangeAll(allChecked)
									}}
									onClick={(e) => {
										e.preventDefault()
										selectAllDocs()
									}}
								></input>
							</div>
						) : null} */}

						{docsToSHow.count > 0
							? docsToSHow.data.map((item, i) => (
									<div
										key={item.id}
										className="conceptLoaded row divElementBorder mb-2 mt-4"
										onMouseOver={(e) => {
											e.preventDefault()
											if (showingCommentBox === true) {
												return
											}
											setItemId(item.id)
										}}
										onMouseLeave={(e) => {
											e.preventDefault()
											if (showingCommentBox === true) {
												return
											}
											setItemId("")
										}}
										style={
											showingCommentBox === false
												? item.id === itemId
													? { borderBottom: "1px solid black", background: "beige", zIndex: 2 }
													: null
												: item.id === itemId
												? { position: "relative", zIndex: 1 }
												: { position: "relative", zIndex: -1 }
										}
										data-cy="document_from_list"
									>
										<div className="col-12 d-flex  divElement">
											<div
												className="col-3 divBlock"
												// dangerouslySetInnerHTML={operationsHelper.getDocumentType(item.source)}
												dangerouslySetInnerHTML={sourceHelper.getsource(item.source)}
											></div>
											<div className="col-3 divBlock">
												<span style={{ fontSize: "10px" }}>
													{item.hasOwnProperty("tagged_date") && item.tagged_date !== null
														? new Date(item.tagged_date).toLocaleString("en-US", {
																year: "numeric",
																month: "long",
																day: "2-digit",
														  })
														: new Date(item.creation_time).toLocaleString("en-US", {
																year: "numeric",
																month: "long",
																day: "2-digit",
														  })}
												</span>
											</div>
										</div>
										<div className="col-12 divElement mt-2">
											<div className="divBlock">
												{activeCheckbox ? (
													<input
														key={`bulk_checkbox_${item.id}`}
														type="checkbox"
														checked={bulkChecked[i]}
														className="form-check-input"
														onChange={(e) => {
															e.preventDefault()
															handleChange(i)
														}}
														onClick={(e) => {
															e.preventDefault()
															updateDocumentsBulk(item.id, item.title)
														}}
													></input>
												) : null}
											</div>
											<div
												id={item.id}
												className="col-8 divBlock relativo"
												style={{ cursor: "pointer", position: "relative", zIndex: "1" }}
												onClick={(e) => {
													e.preventDefault()
													if (showingCommentBox === true || e.target.className.includes("comentario-icon")) {
														return
													}
													timer = setTimeout(function () {
														if (!prevent) {
															handleOpen()
															/*setItem({
                                                        idItem: item.id,
                                                        contentItem: item.content,
                                                        source: item.source,
                                                        title: item.title,
                                                        date: (item.hasOwnProperty('tagged_date') &&  item.tagged_date !==null && item.tagged_date !== undefined ? item.tagged_date : Math.floor(Date.now() / 1000) )
                                                    });
            
                                                    
            
                                                    getDocumentContent(item.id, item.content);
                                                    updateCommentList(item.id);
                                                    setShowingCommentBoxId(item.id);*/

															handleRecordClick(item.id)
														}
														prevent = false
													}, delay)
												}}
												onDoubleClick={(e) => {
													e.preventDefault()
													if (showingCommentBox === true || e.target.className.includes("comentario-icon")) {
														return
													}
													clearTimeout(timer)
													prevent = true
													setItem({
														idItem: item.id,
														contentItem: item.content,
														source: item.source,
														title: item.title,
														date:
															item.hasOwnProperty("tagged_date") &&
															item.tagged_date !== null &&
															item.tagged_date !== undefined
																? item.tagged_date
																: Math.floor(Date.now() / 1000),
													})
													dispatch(documentsActions.downloadDocumentAction(item.id, item.file_name))
												}}
											>
												{item?.attachments > 0 && (
													<i
														className="bi bi-paperclip attachments"
														title={`${item?.attachments} attachment${item?.attachments > 1 ? "s" : ""}`}
													></i>
												)}
												<span className="font-12 px-2">
													{item?.id && (
														<div
															id={`doc_id_${item.id}`}
															className="box"
															style={{
																backgroundColor: item?.tags
																	? operationsHelper.getTagColor(item?.tags, tagsApi)
																	: "#E2E2E2",
															}}
														></div>
													)}
													<strong>
														{!item.hasOwnProperty("title") || item.title === null
															? null
															: item.title.length <= 40
															? item.title
															: item.title.substring(0, 40) + "..."}
													</strong>
												</span>
												<br></br>
												<span>{item.filepath}</span>
											</div>

											{item.id === itemId ? (
												<div className="col-4 divBlockRight">
													<div className="col-12 divBlock">
														{selectIdentify.show ? (
															<div
																className="popup-selectIdentify"
																style={{ marginTop: "20px" }}
																ref={wrapperRef}
															>
																<ul>
																	{tagsApi && tagsApi.hasOwnProperty("tags")
																		? tagsApi.tags.map((element, i) => (
																				<li
																					key={`tag_id_${element.id}`}
																					data-cy={element.name}
																					onClick={(e) => {
																						let tag_id = element.id
																						let elementId = item.id
																						let color = element.color_id
																						updateSelectIdentify(tag_id, elementId)
																					}}
																					onMouseOver={(e) => {
																						e.preventDefault()
																						setSelectOver(i + 1)
																					}}
																					onMouseOut={(e) => {
																						e.preventDefault()
																						setSelectOver(false)
																					}}
																					style={
																						selectOver === i + 1
																							? {
																									backgroundColor: "lightgray",
																									cursor: "pointer",
																							  }
																							: { cursor: "pointer" }
																					}
																				>
																					<div
																						className="box"
																						style={{ backgroundColor: item.color_id }}
																					></div>
																					<span className="ml-10">{item.name}</span>
																				</li>
																		  ))
																		: null}
																</ul>
															</div>
														) : null}
														<div className="col-4 divBlock d-flex justify-content-center">
															<TagsUpdateDropdown
																idItem={item.id}
																updateSelectIdentify={updateSelectIdentify}
															/>
														</div>
														<div className="col-3 divBlock hide">
															<a href="/#" className="ml-1 mr-1 font-12">
																Print
															</a>
														</div>
														<div className="col-5 divBlock d-flex justify-content-center">
															<a
																data-cy="download_doc"
																href="/#"
																className="ml-1 mr-1 font-12"
																style={{ textDecoration: "none" }}
																onClick={(e) => {
																	e.preventDefault()
																	dispatch(
																		documentsActions.downloadDocumentAction(item.id, item.file_name)
																	)
																}}
															>
																{item.hasOwnProperty("id") &&
																downloadDocs.hasOwnProperty(item.id) &&
																downloadDocs[item.id].downloading === true ? (
																	<div
																		className="spinner-border text-dark"
																		role="status"
																		style={{ width: "15px", height: "15px" }}
																	>
																		<span className="visually-hidden">Loading...</span>
																	</div>
																) : (
																	<i className="bi bi-download"></i>
																)}{" "}
																Download
																{item.hasOwnProperty("id") &&
																downloadDocs.hasOwnProperty(item.id) &&
																downloadDocs[item.id].downloading === true ? (
																	<span className="percentage">
																		{" "}
																		({downloadDocs[item.id].percentage}%)
																	</span>
																) : null}
															</a>
														</div>
														{/* <div className="col-2 divBlock d-flex justify-content-center">
                                                    <a href={`mailto:?subject=Anzyz Project – Shared Document&body=Please, download this set of documents: ${window.location.protocol}//${window.location.host}/downloads?downloads=${item.id}`} className="ml-1 mr-1 font-12"

                                                    >Share</a>
                                                </div> */}
														<div className="col-3 divBlock d-flex justify-content-center">
															<i
																className="fas fa-solid fa-comment comentario-icon"
																onClick={(e) => {
																	e.preventDefault()
																	setShowingCommentBox(true)
																	updateCommentList(item.id)
																	setShowingCommentBoxId(item.id)
																}}
															>
																<span style={{ fontSize: "12px", verticalAlign: "middel" }}>
																	{item.comments_count}
																</span>
															</i>
															<CommentsList
																showingCommentBoxId={showingCommentBoxId}
																setShowingCommentBox={setShowingCommentBox}
																item={item}
																commentList={commentList}
																idElement={idElement}
																setIdElement={setIdElement}
																setShowingCommentBoxId={setShowingCommentBoxId}
																updateCommentCount={updateCommentCount}
															/>
														</div>
													</div>
												</div>
											) : null}
										</div>
									</div>
							  ))
							: null}

						{/* ************ PAGINATION ************ */}
						{/* {pageCount > 1 && (<>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <MUIPagination
                                    count={pageCount}
                                    color="primary"
                                    shape="rounded"
                                    defaultPage={page}
                                    page={page}
                                    onChange={(event, value) => updatePageNumber(event, value)}
                                />
                            </div>
                        </>)} */}

						{/* <Pagination
                currentpage = {currentpage}
                prevPage = {prevPage}
                totalpages = {totalpages}
                docsToSHow = {docsToSHow}
                nextPage = {nextPage}
                setCurrentPage = {setCurrentPage}
            /> */}
						{/* ************ END PAGINATION s************ */}

						<div data-cy="element_modal">
							<DocumentModal
								open={open}
								handleClose={handleClose}
								selectDateDocument={selectDateDocument}
								wrapperRef={wrapperRef}
								updateSelectDateDocument={updateSelectDateDocument}
								updateDateDocument={updateDateDocument}
								updateSelectIdentify={updateSelectIdentify}
								showSelectDateDocument={showSelectDateDocument}
								maskHighlight={maskHightlight}
								moveToHighlight={moveToHightlight}
								updateCommentCount={updateCommentCount}
							/>
							{/* <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                <div id="element_modal" style={modalStyle} className={classes.paper}>
                                    <div className="col-12 divBlockModal" style={{ backgroundColor: 'white' }}>
                                        {selectDateDocument.show ?
                                            <div className="selectDateDocument" ref={wrapperRef}>
                                                <ul>
                                                    <li>
                                                        <span style={{ fontSize: '13px' }}><strong>Actual date: </strong></span>
                                                        <br></br>
                                                        <span style={{ fontSize: '14px' }}>
                                                            {
                                                                new Date(item.date).toLocaleString('en-US', {
                                                                    year: 'numeric',
                                                                    month: 'long',
                                                                    day: '2-digit',
                                                                })
                                                            }
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span style={{ fontSize: '13px' }}><strong>New date: </strong></span>
                                                        <br></br>
                                                        <form
                                                            className="d-flex justify-content-center"
                                                            onSubmit={updateDateDocument}
                                                        >
                                                            <input
                                                                type='date'
                                                                name='date'
                                                                onChange={updateSelectDateDocument}
                                                                data-cy="date_document_input"
                                                            />
                                                            <button
                                                                type='submit'
                                                                className={selectDateDocument.date ? "btn btn-primary btn-sm" : "btn btn-primary btn-sm disabled"}
                                                                style={{ marginLeft: '10px' }}
                                                                data-cy="update_modal_button"
                                                            >
                                                                Update
                                                            </button>
                                                        </form>
                                                    </li>
                                                </ul>

                                            </div>
                                            : null}


                                        <div className="col-12 d-flex justify-content-center">

                                            <div className="col-2 divBlock d-flex justify-content-center">
                                                <a
                                                    data-cy="highlight_modal_button"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        moveToHightlight();
                                                    }}
                                                    className="btnModal"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <i className="bi bi-star"></i> Highlight
                                                </a>
                                            </div>

                                            <div className="col-2 divBlock d-flex justify-content-center">
                                                <TagsUpdateDropdown
                                                    idItem={item.idItem}
                                                    updateSelectIdentify={updateSelectIdentify}
                                                />
                                            </div>
                                            <div className="col-3 divBlock d-flex justify-content-center">
                                                <button
                                                    data-cy="date_document_modal"
                                                    className="btnModal"
                                                    onClick={(e) => { showSelectDateDocument(e); }}
                                                >
                                                    <i className="bi bi-calendar-check"></i> Date document
                                                </button>

                                            </div>

                                            <div className="col-2 divBlock d-flex justify-content-center">
                                                <button
                                                    data-cy="download_modal_button"
                                                    className="btnModal"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        dispatch(documentsActions.downloadDocumentAction(item.idItem, item.file_name))
                                                    }}
                                                >
                                                    {downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading === true ?
                                                        <div className="spinner-border text-dark" role="status" style={{ width: '15px', height: '15px' }}>
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                        :
                                                        <i className="bi bi-download"></i>

                                                    } Download
                                                    {item.hasOwnProperty("id") && downloadDocs.hasOwnProperty(item.id) && downloadDocs[item.idItem].downloading === true ?
                                                        <span className="percentage"> ({downloadDocs[item.idItem].percentage}%)</span>
                                                        :
                                                        null
                                                    }
                                                </button>
                                            </div>
                                            <div className="col-3 divBlock d-flex justify-content-center">
                                                <PrevNextButtons
                                                    currentDocId={item.idItem}
                                                    currentPage={item.pageNum}
                                                    totalPages={item.totalPages}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-12 divBlockModal mt-1" style={{ backgroundColor: 'white' }}>
                                        {(content.errorDocumentText) ? <p className="alert alert-danger">Error loading content for this document</p> : null}
                                        {documentLoading ?
                                            <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                <div className="d-flex align-items-center alert alert-warning">
                                                    <strong className="loading">Loading...</strong>
                                                    <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                </div>
                                            </div>
                                            : (<>
                                                <div>
                                                    <div id="divModal" className="divScroll divScrollMax655">
                                                        <div className="mt-3 mb-3">
                                                            <MetadataLayout
                                                                content={content}
                                                                item={item}
                                                                maskHightlight={maskHightlight}
                                                            >
                                                            </MetadataLayout>
                                                        </div>
                                                        <p id="document_content_div"
                                                            dangerouslySetInnerHTML={maskHightlight(content.documentText, item.idItem)}
                                                        ></p>
                                                        <CommentsDetailsModal
                                                            commentsCount={commentList?.length || 0}
                                                            commentList={commentList}
                                                            docId={item.idItem}
                                                            updateCommentCount={updateCommentCount}
                                                        />
                                                    </div>
                                                </div>
                                            </>)}
                                    </div>
                                </div>
                            </Modal> */}
						</div>
					</>
				)}
				{isLoading && <div style={{ minHeight: "800px" }}></div>}
				{pageCount > 1 && (
					<>
						<div className="d-flex justify-content-center mt-5 mb-5">
							<MUIPagination
								count={pageCount}
								color="primary"
								shape="rounded"
								defaultPage={page}
								page={page}
								onChange={(event, value) => updatePageNumber(event, value)}
							/>
						</div>
					</>
				)}
			</Fragment>
		</div>
	)
}
